<template>
    <div :class="$style.variantItem">
        <SelectItem
            aria-label="subject-key"
            :size="'small'"
            v-model="currFilter.key"
            :valueKey="'key'"
            :options="typeOptions"
            :placeholder="$t('goals.select_event_property_placeholder')"
            :allowCreate="false"
            :filterable="true"
            :remoteLoading="false"
            @change="
                handleChange(
                    'filterItem',
                    typeOptions && typeOptions.find(item => item.key === $event)
                )
            "
        ></SelectItem>

        <SelectItem
            aria-label="subject-operator"
            v-if="visibleStates.filterCondition"
            :size="'small'"
            v-model="currFilter.condition"
            :valueKey="'code'"
            :options="options.filterCondition"
            :placeholder="$t('common.select_placeholder')"
            :allowCreate="false"
            :filterable="true"
            :remoteLoading="false"
            @change="
                handleChange(
                    'filterCondition',
                    options.filterCondition &&
                        options.filterCondition.find(item => item.code === $event)
                )
            "
        ></SelectItem>

        <FilterValue
            aria-label="subject-value"
            v-if="
                visibleStates.filterValue &&
                state.filterItem &&
                (state.filterItem.valueNeedQuery === false || options.filterValue)
            "
            :sid="sid"
            :cType="filterValueType"
            :is-new-value-method="isNewValueMethod"
            :is-use-slots="isUseSlots"
            :size="filterValueSize"
            :timeZone="timeZone"
            :curr-filter="currFilter"
            :value="formatValue"
            :options="options.filterValue"
            :options-loading="fetchStates.filterValue.loading"
            :filter-item="state.filterItem"
            :index="index"
            :filter-condition="state.filterCondition"
            @change="handleChange"
        ></FilterValue>

        <div :class="$style['button-remove']" @click="handleDelete">
            <pt-icon
                icon="pt-icon--close"
                :icon-style="{
                    width: '16px',
                    height: '16px'
                }"
            ></pt-icon>
        </div>
    </div>
</template>

<script>
import { cloneDeep } from 'lodash-es';
import SelectItem from '../items/item-select.vue';
import FilterValue from './FilterValue.vue';
import usersApis from '@/apis/users.apis';
import { searchTree, getNextStepForCondition } from '../../../usergrp-util';

export default {
    name: 'Subjects',
    components: {
        SelectItem,
        FilterValue
    },
    props: {
        eventName: {
            type: String,
            required: true
        },
        typeOptions: {
            type: Array,
            required: true
        },
        sid: {
            type: String,
            required: true
        },
        timeZone: {
            type: String,
            required: true
        },
        where: {
            type: Object,
            required: true
        },
        filterLen: {
            type: Number,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            state: {
                filterItem: this.where,
                filterCondition: undefined,
                filterValue: undefined
            },
            visibleStates: {},
            options: {
                filterItem: this.typeOptions,
                filterCondition: undefined,
                filterValue: undefined
            },
            fetchStates: {
                filterValue: {
                    loading: false,
                    reqId: 'fetchValueOptions',
                    controller: null
                }
            },
            currFilter: this.where ? { ...this.where } : {}
        };
    },
    computed: {
        filterValueType() {
            const { filterItem, filterCondition } = this.state;
            return (filterItem && filterItem.cType) || (filterCondition && filterCondition.cType); //有指定组件类型则优先使用
        },

        isUseSlots() {
            const { filterItem, filterCondition } = this.state;
            return (
                (filterItem && filterItem.isUseSlots) ||
                (filterCondition && filterCondition.isUseSlots)
            ); //有指定组件类型则优先使用
        },

        isNewValueMethod() {
            const { filterItem, filterCondition } = this.state;
            return (
                (filterItem && filterItem.isNewValueMethod) ||
                (filterCondition && filterCondition.isNewValueMethod)
            ); //有指定组件类型则优先使用
        },

        filterValueSize() {
            const { filterItem, filterCondition } = this.state;
            return (filterItem && filterItem.size) || (filterCondition && filterCondition.size);
        },

        formatValue() {
            return this.currFilter.value;
        },

        filterValueType() {
            const { filterItem, filterCondition } = this.state;
            return (filterItem && filterItem.cType) || (filterCondition && filterCondition.cType);
        }
    },
    watch: {
        where: {
            handler(val) {
                if (val) {
                    this.currFilter = { ...val };
                }
                this.init();
            },
            deep: true
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            const { key, condition, value } = this.currFilter;
            this.setState('filterItem', key, 'key');
            this.setFilterConditionOptions();
            this.setState('filterCondition', condition || this.state.filterItem?.defaultCondition);
            this.setFilterValueOptions();
            this.updateStates('filterValue', value);
            this.updateVisibleStates();
        },
        handleChange(type, value) {
            let needUpdate = true;
            switch (type) {
                case 'filterItem': {
                    const { defaultCondition } = value || {};
                    this.updateStates(type, value);
                    this.setFilterConditionOptions();
                    this.setState('filterCondition', defaultCondition);
                    this.setFilterValueOptions();
                    this.updateStates('filterValue', undefined);
                    this.updateVisibleStates();
                    needUpdate = (this.options.filterCondition || []).length === 0;
                    break;
                }
                case 'filterCondition':
                case 'filterValue':
                    this.updateStates(type, value);
                    this.updateVisibleStates();
                    break;
                default:
                    this.updateStates(type, value);
                    break;
            }
            this._updateFilter(type, needUpdate);
        },
        setFilterConditionOptions() {
            const { type } = this.state.filterItem || {};
            const optionsVar = type ? getNextStepForCondition(type.toLocaleLowerCase(), true) : [];
            this.updateOptions('filterCondition', optionsVar);
        },
        fetchDictData(params) {
            const { funName, propertyKey, subKey, signal } = params;
            return usersApis.getDictData(null, {
                where: {
                    sid: this.sid,
                    funName,
                    propertyKey,
                    subKey,
                    timeZone: this.timeZone,
                    limit: 100
                },
                signal
            });
        },
        async setFilterValueOptions() {
            const { key } = this.state.filterItem || {};
            if (this.fetchStates.filterValue.loading && this.fetchStates.filterValue.controller) {
                this.fetchStates.filterValue.controller.abort();
                this.fetchStates.filterValue.controller = null;
            }
            this.fetchStates.filterValue.loading = true;
            const controller = new AbortController();
            this.fetchStates.filterValue.controller = controller;
            try {
                const data = await this.fetchDictData({
                    funName: 'eventPropertyValue',
                    propertyKey: this.eventName,
                    subKey: key,
                    signal: controller.signal
                });
                const results =
                    data?.map(item => ({
                        code: item.key,
                        name: item.key
                    })) || [];
                this.updateOptions('filterValue', results);
            } catch (e) {
                if (e.name !== 'AbortError') {
                    // 处理其他错误
                }
            } finally {
                this.fetchStates.filterValue.loading = false;
                this.fetchStates.filterValue.controller = null;
            }
        },
        updateOptions(key, value) {
            this.options[key] = value;
        },
        updateStates(key, value) {
            this.state[key] = value;
        },
        updateVisibleStates() {
            const { filterItem, filterValue, filterCondition } = this.state;
            const { key, type } = filterItem || {};
            this.visibleStates = {};
            Object.keys(this.state).forEach(stateName => {
                let visible = true;
                let hasComponent = true;
                switch (stateName) {
                    case 'filterCondition':
                        hasComponent = Boolean(key);
                        visible = Boolean(filterItem);
                        break;
                    case 'filterValue': {
                        const { hasValue } = filterCondition || {};
                        hasComponent = hasValue;
                        visible = Boolean(filterItem);
                        break;
                    }
                }
                if (hasComponent) this.visibleStates[stateName] = visible;
            });
        },
        _updateFilter(stateName, needUpdate) {
            const { filterItem, filterCondition, filterValue } = this.state;
            const mapper = {
                filterItem: () => {
                    if (!filterItem) return;
                    const { key, type: itemType, defaultCondition } = filterItem;
                    this.updateFilter('key', key);
                    this.updateFilter('type', itemType);
                    this.updateFilter('value', null);
                    this.updateFilter('condition', defaultCondition);
                },
                filterCondition: () => {
                    const { code, hasValue } = filterCondition || {};
                    this.updateFilter('condition', code);
                    if (!hasValue) {
                        this.updateFilter('value', []);
                    }
                },
                filterValue: () => {
                    const curVal =
                        (filterValue !== undefined &&
                            (Array.isArray(filterValue) ? filterValue : [filterValue])) ||
                        null;
                    this.updateFilter('value', curVal);
                }
            };
            if (mapper[stateName]) mapper[stateName]();
            if (needUpdate) {
                this.notice();
            }
        },
        notice() {
            const { key, value } = this.currFilter;
            const { filterValue } = this.visibleStates;
            const hasSubjectWhereKey = Boolean(key);
            const hasValue = filterValue !== undefined && Array.isArray(value) && value.length > 0;
            this.currFilter['error'] = {
                type: !hasSubjectWhereKey,
                value: !hasValue
            };
            if (hasSubjectWhereKey && hasValue && this.currFilter) {
                this.$emit('change', cloneDeep(this.currFilter));
            }
        },
        updateFilter(key, value) {
            this.$set(this.currFilter, key, value);
        },
        setState(key, code, val) {
            const optionsVar = this.options[key] || [];
            const itemInfo = val
                ? code && searchTree(optionsVar, code, val)
                : code && searchTree(optionsVar, code);
            this.updateStates(key, itemInfo);
        },
        handleDelete() {
            this.$emit('delete');
        }
    }
};
</script>

<style lang="scss" module>
@import '@/styles/import.scss';

.variantItem {
    display: flex;
    align-items: center;
    position: relative;
    gap: 8px;

    // 事件属性Key和事件操作符
    > [aria-label='subject-key'],
    > [aria-label='subject-operator'] {
        flex: 1;
        max-width: calc((100% - 428px - 62px) / 2);
    }

    // 事件属性值
    > [aria-label='subject-value'] {
        flex: 0 0 446px;

        :global {
            .pt-input__number {
                height: 32px !important;
                border-color: $pt-black-50 !important;
            }
        }
    }

    .button-remove {
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        cursor: pointer;

        &:hover {
            svg {
                fill: $pt-black-600;
            }
        }

        svg {
            fill: $pt-black-300;
        }
    }
}
</style>
